import React, {memo, useContext, useEffect} from 'react';
import classes from './DeviceList.module.scss';
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import Loader from "../components/Loader";
import DeviceCard from "../components/DeviceCard";

const DeviceList = observer(() => {
    const {things} = useContext(Context);
    const {ui} = useContext(Context);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <h1>Устройства</h1>
            <div className={classes.container}>
                <div className={classes.name}>
                    <div className={classes.item} style={ui.isSerialNumber ? {display: 'block'} : {display: 'none'}}>Серийный<br/>номер</div>
                    <div className={classes.item} style={ui.isModel ? {display: 'block'} : {display: 'none'}}>Модель</div>
                    <div className={classes.item} style={ui.isSerialNumberMachine ? {display: 'block'} : {display: 'none'}}>Серийный номер<br/>машины</div>
                    <div className={classes.item} style={ui.isCity ? {display: 'block'} : {display: 'none'}}>Город</div>
                    <div className={classes.item} style={ui.isAddress ? {display: 'block'} : {display: 'none'}}>Адрес</div>
                    <div className={classes.item} style={ui.isObject ? {display: 'block'} : {display: 'none'}}>Объект</div>
                    <div className={classes.item} style={ui.isStatus ? {display: 'block'} : {display: 'none'}}>Статус</div>
                </div>
                <hr/>
                    {ui.isDeviceList
                        ? <DeviceCard devices={things.data}/>
                        : <div className={classes.loader}><Loader/></div>}
            </div>
        </>
    );
});

export default DeviceList;